/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ChatMessageSendingJobNewPageQuotaFragment = { lineMessagingCurrentMonthQuota: { totalUsage: number, quota:
      | { __typename: 'LineMessagingCurrentMonthQuota_Limited', limit: number }
      | { __typename: 'LineMessagingCurrentMonthQuota_None', void: any }
     } };

export const ChatMessageSendingJobNewPageQuotaFragmentDoc = gql`
    fragment ChatMessageSendingJobNewPageQuota on Query {
  lineMessagingCurrentMonthQuota {
    quota {
      __typename
      ... on LineMessagingCurrentMonthQuota_None {
        void
      }
      ... on LineMessagingCurrentMonthQuota_Limited {
        limit
      }
    }
    totalUsage
  }
}
    `;